import { lazy } from 'react';
import { RouteObject, Navigate } from 'react-router-dom';
import { ModuleGuard } from '@shared/module-kit';

const AgentProductivityPage = lazy(() => import('./pages/AgentProductivityPage'));
const CsatPage = lazy(() => import('./pages/CsatPage'));
const FcrPage = lazy(() => import('./pages/FcrPage'));
const CesPage = lazy(() => import('./pages/CesPage'));
const VolumeTrendsPage = lazy(() => import('./pages/VolumeTrendsPage'));
const EscalationPatternsPage = lazy(() => import('./pages/EscalationPatternsPage'));

export const AnalyticsRoutes: RouteObject = {
  path: 'analytics',
  element: <ModuleGuard moduleId="support.analytics" />,
  handle: { crumb: 'Support Analytics' },
  children: [
    { index: true, element: <Navigate to="agent-productivity" replace /> },
    { path: 'agent-productivity', element: <AgentProductivityPage />, handle: { crumb: 'Agent Productivity' } },
    { path: 'csat', element: <CsatPage />, handle: { crumb: 'CSAT' } },
    { path: 'fcr', element: <FcrPage />, handle: { crumb: 'FCR' } },
    { path: 'ces', element: <CesPage />, handle: { crumb: 'CES' } },
    { path: 'volume-trends', element: <VolumeTrendsPage />, handle: { crumb: 'Volume Trends' } },
    { path: 'escalation-patterns', element: <EscalationPatternsPage />, handle: { crumb: 'Escalation Patterns' } },
  ],
};
